export default __webpack_public_path__ + "static/media/follow.69c317de.png";